/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { PageInfoDto } from '../models/page-info-dto';
import { shopProductAdminControllerCreateV1 } from '../fn/shop-product-admin/shop-product-admin-controller-create-v-1';
import { ShopProductAdminControllerCreateV1$Params } from '../fn/shop-product-admin/shop-product-admin-controller-create-v-1';
import { shopProductAdminControllerFindByIdV1 } from '../fn/shop-product-admin/shop-product-admin-controller-find-by-id-v-1';
import { ShopProductAdminControllerFindByIdV1$Params } from '../fn/shop-product-admin/shop-product-admin-controller-find-by-id-v-1';
import { shopProductAdminControllerRemoveV1 } from '../fn/shop-product-admin/shop-product-admin-controller-remove-v-1';
import { ShopProductAdminControllerRemoveV1$Params } from '../fn/shop-product-admin/shop-product-admin-controller-remove-v-1';
import { shopProductAdminControllerSearchV1 } from '../fn/shop-product-admin/shop-product-admin-controller-search-v-1';
import { ShopProductAdminControllerSearchV1$Params } from '../fn/shop-product-admin/shop-product-admin-controller-search-v-1';
import { shopProductAdminControllerUpdateStatusV1 } from '../fn/shop-product-admin/shop-product-admin-controller-update-status-v-1';
import { ShopProductAdminControllerUpdateStatusV1$Params } from '../fn/shop-product-admin/shop-product-admin-controller-update-status-v-1';
import { shopProductAdminControllerUpdateV1 } from '../fn/shop-product-admin/shop-product-admin-controller-update-v-1';
import { ShopProductAdminControllerUpdateV1$Params } from '../fn/shop-product-admin/shop-product-admin-controller-update-v-1';
import { ShopProductDto } from '../models/shop-product-dto';

@Injectable({ providedIn: 'root' })
export class ShopProductAdminService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `shopProductAdminControllerSearchV1()` */
  static readonly ShopProductAdminControllerSearchV1Path = '/api/v1/shop-products/admin';

  /**
   * 상품 목록 조회 (관리자).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `shopProductAdminControllerSearchV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  shopProductAdminControllerSearchV1$Response(params: ShopProductAdminControllerSearchV1$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'items': Array<ShopProductDto>;
'pageInfo': PageInfoDto;
}>> {
    const obs = shopProductAdminControllerSearchV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 상품 목록 조회 (관리자).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `shopProductAdminControllerSearchV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  shopProductAdminControllerSearchV1(params: ShopProductAdminControllerSearchV1$Params, context?: HttpContext): Observable<{
'items': Array<ShopProductDto>;
'pageInfo': PageInfoDto;
}> {
    const resp = this.shopProductAdminControllerSearchV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<{
'items': Array<ShopProductDto>;
'pageInfo': PageInfoDto;
}>): {
'items': Array<ShopProductDto>;
'pageInfo': PageInfoDto;
} => r.body)
    );
  }

  /** Path part for operation `shopProductAdminControllerCreateV1()` */
  static readonly ShopProductAdminControllerCreateV1Path = '/api/v1/shop-products/admin';

  /**
   * 상품 등록.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `shopProductAdminControllerCreateV1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  shopProductAdminControllerCreateV1$Response(params: ShopProductAdminControllerCreateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<ShopProductDto>> {
    const obs = shopProductAdminControllerCreateV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 상품 등록.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `shopProductAdminControllerCreateV1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  shopProductAdminControllerCreateV1(params: ShopProductAdminControllerCreateV1$Params, context?: HttpContext): Observable<ShopProductDto> {
    const resp = this.shopProductAdminControllerCreateV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ShopProductDto>): ShopProductDto => r.body)
    );
  }

  /** Path part for operation `shopProductAdminControllerFindByIdV1()` */
  static readonly ShopProductAdminControllerFindByIdV1Path = '/api/v1/shop-products/admin/{id}';

  /**
   * 상품 상세 조회 (관리자).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `shopProductAdminControllerFindByIdV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  shopProductAdminControllerFindByIdV1$Response(params: ShopProductAdminControllerFindByIdV1$Params, context?: HttpContext): Observable<StrictHttpResponse<ShopProductDto>> {
    const obs = shopProductAdminControllerFindByIdV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 상품 상세 조회 (관리자).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `shopProductAdminControllerFindByIdV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  shopProductAdminControllerFindByIdV1(params: ShopProductAdminControllerFindByIdV1$Params, context?: HttpContext): Observable<ShopProductDto> {
    const resp = this.shopProductAdminControllerFindByIdV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ShopProductDto>): ShopProductDto => r.body)
    );
  }

  /** Path part for operation `shopProductAdminControllerRemoveV1()` */
  static readonly ShopProductAdminControllerRemoveV1Path = '/api/v1/shop-products/admin/{id}';

  /**
   * 상품 삭제.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `shopProductAdminControllerRemoveV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  shopProductAdminControllerRemoveV1$Response(params: ShopProductAdminControllerRemoveV1$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = shopProductAdminControllerRemoveV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 상품 삭제.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `shopProductAdminControllerRemoveV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  shopProductAdminControllerRemoveV1(params: ShopProductAdminControllerRemoveV1$Params, context?: HttpContext): Observable<void> {
    const resp = this.shopProductAdminControllerRemoveV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `shopProductAdminControllerUpdateV1()` */
  static readonly ShopProductAdminControllerUpdateV1Path = '/api/v1/shop-products/admin/{id}';

  /**
   * 상품 수정.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `shopProductAdminControllerUpdateV1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  shopProductAdminControllerUpdateV1$Response(params: ShopProductAdminControllerUpdateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<ShopProductDto>> {
    const obs = shopProductAdminControllerUpdateV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 상품 수정.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `shopProductAdminControllerUpdateV1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  shopProductAdminControllerUpdateV1(params: ShopProductAdminControllerUpdateV1$Params, context?: HttpContext): Observable<ShopProductDto> {
    const resp = this.shopProductAdminControllerUpdateV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ShopProductDto>): ShopProductDto => r.body)
    );
  }

  /** Path part for operation `shopProductAdminControllerUpdateStatusV1()` */
  static readonly ShopProductAdminControllerUpdateStatusV1Path = '/api/v1/shop-products/admin/{id}/status';

  /**
   * 상품 상태 변경.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `shopProductAdminControllerUpdateStatusV1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  shopProductAdminControllerUpdateStatusV1$Response(params: ShopProductAdminControllerUpdateStatusV1$Params, context?: HttpContext): Observable<StrictHttpResponse<ShopProductDto>> {
    const obs = shopProductAdminControllerUpdateStatusV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 상품 상태 변경.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `shopProductAdminControllerUpdateStatusV1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  shopProductAdminControllerUpdateStatusV1(params: ShopProductAdminControllerUpdateStatusV1$Params, context?: HttpContext): Observable<ShopProductDto> {
    const resp = this.shopProductAdminControllerUpdateStatusV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ShopProductDto>): ShopProductDto => r.body)
    );
  }

}
